import styled, { css } from 'styled-components';
import { pxToRem } from '@anwb/style-utilities';
export const popoverFooterStyles = ({ theme, $showFade, }) => css `
		&& {
			padding: ${pxToRem(theme.spacing['300'])} ${pxToRem(theme.spacing['500'])}
				${pxToRem(theme.spacing['500'])} ${pxToRem(theme.spacing['500'])};
			text-align: right;
			position: sticky;
			bottom: 0;
			background-color: ${theme.colors.blanc.bgPopover};

			${$showFade &&
    css `
				&::after {
					content: '';
					height: ${pxToRem(theme.spacing['700'])};
					width: 100%;
					display: block;
					position: absolute;
					top: -${pxToRem(theme.spacing['700'])};
					left: 0;
					background: ${theme.colors.gradients.overlayReadMore};
					pointer-events: none;
				}
			`}
		}
	`;
export const PopoverFooterContainer = styled.footer `
	${popoverFooterStyles};
`;
//# sourceMappingURL=popover-footer.styled.js.map